import React, { Component } from "react";
import "./footer.css";

class Footer extends Component {
  state = {};
  render() {
    return (
      <div className="footer">
        <div className="container-fluid cont">
          <div className="row">
            <div className="col-6 ctr">
              <span className="footerP"> © YEX All rights reserved. </span>
            </div>
            <div className="col">
              <div className="row">
                <div className="col-5 right">
                  <a
                    href="https://yoti.world/privacy-policy/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="footerP"> Privacy policy </span>
                  </a>
                </div>
                <div className="col-1 ctr">
                  <span className="footerP">|</span>
                </div>
                <div className="col-5 left">
                  <a
                    href="https://yoti.zendesk.com/hc/en-us"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="footerP"> FAQ </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;
